
export const USERS = [
  { email: "peter@plus.de", password: "68275", role: "admin" }, 
  { email: "rolandas@plus.de", password: "875300", role: "user" },
  { email: "toni@plus.de", password: "875300", role: "user" },
  { email: "nijaz@plus.de", password: "875300", role: "user" },
  { email: "vitor@plus.de", password: "875300", role: "user" },

  { email: "gast1@plus.de", password: "427095", role: "user" },      
  { email: "gast2@plus.de", password: "427095", role: "user" },     
  
  { email: "erwindevelopment@group.de", password: "IchHalt37489", role: "admin" }, 
];



export const EMAILJS_CONFIG = {
  serviceID: 'service_dy03d7a',
  templateID: 'template_8clfozb',
  publicKey: 'zF6MX7-KhcOqCiybE'
}; 